module.exports = __webpack_public_path__ + "static/media/download.8b4388e8.svg";